import React from "react";

export default function InactiveProduct() {
  return (
    <div className="h-screen w-screen flex justify-center items-center">
      <h1 className="text-lg text-red-400">
        Este produto não está disponível para compra, porque ainda está pendente
        de aprovação.
      </h1>
    </div>
  );
}
